module.exports = __webpack_public_path__ + "static/media/home-hero-cover.b86d8ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/home-hero-cover.jpg
// module id = 2659
// module chunks = 0